<div 
  class="box-1" 
  [style]="'padding:' + padding() + 'px;' + 
           '--borderWidth:' + borderWidth() + 'px;' +
           '--borderRadius:' + borderRadius() + 'px;'
          " 
>
  <ng-content />
</div>